import { MemoryStatus } from "models/enumerations/conversations/memory-status";
import ServiceFactory from "../service-factory";
import SuggestMemoryPartRecord from "models/view-models/conversations/suggest-memory-part-record";
import MemoryRecord from "models/view-models/memories/memory-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";
interface ListMemoriesParams {}
interface ResourceMemoryPathParams {
    id: string;
}

interface UpdateMemoryRequest {
    status: MemoryStatus;
}

const baseEndpoint = "memories";
const resourceEndpoint = `${baseEndpoint}/:id`;
const key = "memories";

const MemoriesService = {
    useListQuery: QueryHookFactory.useListQuery<
        MemoryRecord,
        ListMemoriesParams
    >(key, MemoryRecord, baseEndpoint),
    patch: ServiceFactory.patch<
        SuggestMemoryPartRecord,
        ResourceMemoryPathParams,
        UpdateMemoryRequest
    >(SuggestMemoryPartRecord, resourceEndpoint),
    delete: ServiceFactory.delete(resourceEndpoint),
};

export default MemoriesService;
